<template>
  <WCAlert :class="`alert-${variant}`">
    <WCAlertCloseButton @close="close" />
    {{ this.$t('editOrderSuccess') }}
  </WCAlert>
</template>

<script>
import WCAlert from '@/modules/alerts/components/WCAlert/WCAlert.vue';
import AlertMixin from '@/modules/alerts/mixins/AlertMixin';
import WCAlertCloseButton from '@/modules/alerts/components/WCAlertCloseButton/WCAlertCloseButton.vue';

export default {
  name: 'WCOrderInProgressAlert',
  components: { WCAlert, WCAlertCloseButton },
  mixins: [AlertMixin],
};
</script>
